import { BaseSelectors } from '@makemydeal/dr-activities-common';
import type { HostEnvironment } from '@makemydeal/dr-shared-ui-utils';
import type { BridgeUserState } from '@makemydeal/dr-dash-types';
import type { IAdditionalSelectors } from '@makemydeal/dr-sales-checkin-types';
import type { SalesCheckinRootState } from './types/SalesCheckinRootState';

export class Selectors extends BaseSelectors {
    constructor(public sliceName: string, public additionalSelectors: IAdditionalSelectors) {
        super(sliceName);
    }

    /**
     * Get the slice of state for this activity
     * @param state Entire State Tree
     */

    getBridgeId = (state: SalesCheckinRootState): string => {
        const bridgeUserState = this.getBridgeUserState(state);
        return bridgeUserState.id || '';
    };

    getBridgeUsername = (state: SalesCheckinRootState): string => {
        const bridgeUserState = this.getBridgeUserState(state);
        return bridgeUserState.username || '';
    };

    getFullName = (state: SalesCheckinRootState): string => {
        const bridgeUserState = this.getBridgeUserState(state);
        let name = '';
        if (bridgeUserState.givenName != null) name += bridgeUserState.givenName;
        if (bridgeUserState.familyName != null) {
            if (name.length) name += ' ';
            name += bridgeUserState.familyName;
        }
        return name;
    };

    getBridgeFirstName = (state: SalesCheckinRootState): string => {
        const bridgeUserState = this.getBridgeUserState(state);
        return bridgeUserState.givenName || '';
    };

    getBridgeLastName = (state: SalesCheckinRootState): string => {
        const bridgeUserState = this.getBridgeUserState(state);
        return bridgeUserState.familyName || '';
    };

    getBridgeUserState = (state: SalesCheckinRootState): Partial<BridgeUserState> => {
        return state.bridgeUser || {};
    };

    getState = (state: SalesCheckinRootState) => {
        return super.getState(state);
    };

    getEnvironment = (state: SalesCheckinRootState): HostEnvironment | undefined => {
        return this.getState(state).environment;
    };
}
